/* eslint-disable class-methods-use-this */
/* eslint-disable max-classes-per-file */
import { RequestBase } from '../requestBase';
import { APIRoutes } from '../apiRoutes';

export class RequestCatalogLogin extends RequestBase {

  public override getAPIEndPoint(): string {
    return APIRoutes.Users_Catalog_Login;
  }

  public user = '';
  public channelPassword = '';
  public channel = '';
  public catalogKey = '';
}

export class ResponseCatalogLogin {
  public result = false;
  public tokenData = '';
}
